


















import Vue, { PropType } from 'vue';
import { CheckboxValue, CheckboxChecked } from '@/models/checkbox';

export default Vue.extend({
  name: 'ASwitcher',
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: {
      type: [Boolean, Array] as PropType<CheckboxChecked>,
      default: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    value: null as CheckboxValue,
    label: { type: String, default: '' },
    disabled: Boolean,
  },
  computed: {
    localChecked: {
      get(): CheckboxChecked {
        return this.checked;
      },
      set(checked: CheckboxChecked) {
        this.$emit('change', checked);
      },
    },
  },
});
